import React from "react";

/**
 * @param {object} props
 * @param {'demo'|'production'} [props.mode]
 * @param {string} [props.phaseLabel]
 * @param {string} [props.demoMessage]
 * @param {string} [props.version]
 * @param {React.ReactNode} [props.extra]
 * @param {string} [props.testId]
 */
export function GsdDemoModeBanner({
  mode = "demo",
  phaseLabel,
  demoMessage,
  version,
  extra,
  testId = "gsd-demo-mode-banner",
}) {
  if (mode !== "demo") return null;
  return (
    <div className="gsd-demo-banner" data-testid={testId}>
      <span className="gsd-demo-banner__badge" data-testid="gsd-demo-badge">
        [DÉMO]
      </span>
      {phaseLabel ? <span className="gsd-demo-banner__phase">{phaseLabel}</span> : null}
      {demoMessage ? <span className="gsd-demo-banner__message">{demoMessage}</span> : null}
      {version ? (
        <span className="gsd-demo-banner__version" data-testid="gsd-app-version-banner">
          v{version}
        </span>
      ) : null}
      {extra}
    </div>
  );
}
